import { useState } from "react";
import { guideSteps } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function GuideSection() {
  const [openId, setOpenId] = useState<string | null>(guideSteps[0]?.id ?? null);

  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="观影指南"
              title="四步选片法，帮你少走弯路"
              desc="如果你刚接触伦理片，或者每次都挑很久还定不下来，可以按下面四步依次判断。每一条都可以展开查看更具体的建议，内容已在页面中，点开即可阅读。"
            />
            <div className="mt-6 rounded-lg border border-background-300 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-lightbulb-line text-lg text-primary-600"></i>
                小提示
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                不必四步全走完。多数情况下，先确定情绪和题材方向，再看一眼评分，就足够做出一个不容易后悔的选择了。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-background-300 rounded-lg border border-background-300 bg-background-50">
              {guideSteps.map((step, index) => {
                const isOpen = openId === step.id;
                return (
                  <div key={step.id}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenId(isOpen ? null : step.id)}
                        className="flex w-full items-start gap-4 px-5 py-5 text-left"
                      >
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-label text-sm transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                          }`}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        <span className="flex-1">
                          <span className="block font-heading text-base text-foreground-950">{step.title}</span>
                          <span className="mt-1 block text-sm text-foreground-600">{step.summary}</span>
                        </span>
                        <i
                          className={`ri-arrow-down-s-line mt-1 shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                            isOpen ? "rotate-180" : ""
                          }`}
                        ></i>
                      </button>
                    </h3>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 pl-[4.25rem] text-sm leading-relaxed text-foreground-700">
                          {step.detail}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}